import { render, staticRenderFns } from "./NyscDetails.vue?vue&type=template&id=df8f32b8"
import script from "./NyscDetails.vue?vue&type=script&lang=js"
export * from "./NyscDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports